<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述：用电统计
    -->
	<div class="meter-charge">
		<strong>金额合计：{{allTotal}} 元</strong>
		<div class="meter_search" style="margin-top: 10px;">
			<el-form :inline="true" :model="seach" class="demo-form-inline" @keyup.enter.native="search">
				<el-form-item label="选择开始日期">
					<el-date-picker
				      v-model="seach.value2"
				      type="date"
				      placeholder="选择开始日期"
				      >
				    </el-date-picker>
				</el-form-item>
				<el-form-item label="选择结束日期">
					<el-date-picker
				      v-model="seach.value3"
				      type="date"
				      placeholder="选择结束日期"
				      >
				    </el-date-picker>
				</el-form-item>
				<el-form-item label="户号">
					<el-input v-model="seach.account" placeholder="户号" style="width:100px;" :maxlength="12"></el-input>
				</el-form-item>
				<el-form-item label="表号">
					<el-input v-model="seach.code" placeholder="表号" style="width:100px;" :maxlength="12"></el-input>
				</el-form-item>
				<el-form-item label="表类型">
					<el-select v-model="seach.typess" placeholder="请选择" style="width: 90px;">
						<el-option v-for="item in typess" :key="item.id" :label="item.label" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="业主类型">
				<el-select v-model="seach.nature" placeholder="请选择" style="width: 110px;">
				    <el-option
						v-for="item in natures"
						:key="item.num"
						:label="item.value"
						:value="item.num">
					</el-option>
				 </el-select>
			</el-form-item>
				<el-form-item label="业主姓名">
					<el-input v-model="seach.owner_name" placeholder="业主姓名" style="width:90px;"></el-input>
				</el-form-item>
				<!--<el-form-item label="业主手机">
					<el-input v-model="seach.owner_phone" placeholder="业主手机" style="width:120px;" :maxlength="11"></el-input>
				</el-form-item>-->
				<el-form-item label="地址">
					 <el-input v-model="seach.community_name" placeholder="地址" style="width:120px;"></el-input>
				</el-form-item>
					<el-button type="primary" @click="search">查询</el-button>
					<el-button type="primary" @click="resetting">重置</el-button>
					<el-button type="primary" @click="downmeterCharge()">导出</el-button>
				</el-form-item>
			</el-form>
		</div>
		<el-table :data="lists" border style="width:1652px;text-align:center;margin-bottom: 10px;font-size:12px;margin-top: 10px; " v-on:sort-change="sortChange">
				<!--<el-table-column prop="community_name" label="小区名称" width="150" align="center" sortable="custom" width="205" width="228"width="123"width="110"width="158"width="240">
				</el-table-column>-->
				<el-table-column prop="account" label="户号"  align="center" sortable="custom" >
				</el-table-column>
				<el-table-column prop="code" label="表号"  align="center" sortable="custom" >
				</el-table-column>
				<el-table-column prop="tra_type" label="表类型"  align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="total_charge" label="累计用量（度/吨）"  align="center" sortable="custom" >
				</el-table-column>
				<el-table-column prop="total_money" label="累计用量金额" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="nature" label="业主类型"  align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="owner_name" label="业主姓名"  align="center" sortable="custom">
				</el-table-column>
				<!--<el-table-column prop="owner_phone" label="业主手机" width="123" align="center" sortable="custom">
				</el-table-column>-->
				<el-table-column prop="address" label="地址"  align="center" sortable="custom">
				</el-table-column>
				<!--<el-table-column prop="type" label="电表类型" width="115" align="center" sortable="custom">
				</el-table-column>-->
				<!--<el-table-column prop="plan_name" label="计量方案" width="185" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="rate" label="倍率" width="83" align="center" sortable="custom">
				</el-table-column>-->
		</el-table>
		 <el-pagination
	      @size-change="handleSizeChange"
	      @current-change="handleCurrentChange"
	      :page-size="15"
	      layout="total, prev, pager, next"
	      :total="totel"
	      v-if="showfenpage"
	      >
	    </el-pagination>
	</div>
</template>

<script>
	import { mapState} from 'vuex'
	export default{
		name:'meter-charge',
		data(){
			return{
				seach:{
					value2: '',
					value3:'',
					totel:'',
					code:'',
					account: '',
					owner_name:'',
					owner_phone:'',
					community_name:'',
					nature:'',
					typess:'',
				},
				allTotal:'',
				natures:[
					/*{
						num:'0',
						value:'居民',
					},
					{
						num:'1',
						value:'自营'
					},
					{
						num:"2",
						value:'联营'
					},
					{
						num:'3',
						value:'出租'
					},
					{
						num:'4',
						value:'物业动力'
					},
					{
						num:'5',
						value:'居民配套'
					},
					{
						num:'9',
						value:'备用'
					},*/
					
				],
				typess: [
					{
						id: '7',
						label: '水表'
					},
					{
						id: '10',
						label: '多功能单相'
					},
					{
						id: '11',
						label: '多功能三相'
					}
				],
				showfenpage:false,
				lists:[
					{
						community_name:'',
						code:'',
						account: '',
						address:'',
						owner_name:'',
						owner_phone:'',
						total_charge:'',
						total_money:'',
						left_monty:'',
						plan_name:'',
						type:'',
						rate:'',
						nature:''
					}
				],
				prop:'',
				order:'',
			}
		},
		created:function(){
			this.searchNature()
			this.search()
		},
		methods:{
			searchNature(){
				this.$jssdk.member.getNature({
					
				},(res) =>{
					this.natures = res
					console.log(res)
				})
			},
			sortChange(item) {
				var order = item.order
				var prop = item.prop
				this.prop = prop
				this.order = order
				let time = this.seach.value2
				let endTime = this.seach.value3
				let code = this.seach.code
				let account = this.seach.account
				let name = this.seach.owner_name
				let phone = this.seach.owner_phone
				let nature = this.seach.nature
				let communityName = this.seach.community_name
				let typess = this.seach.typess
		      	this.$jssdk.count.meterCharge({
		      		start_time:time,
		      		end_time:endTime,
					code:code,
					account: account,
		      		owner_name:name,
		      		owner_phone:phone,
		      		community_name:communityName,
		      		is_export:'0',
		      		nature:nature,
		      		sort_by: prop,
					sort_to: order,
					type: typess
		      	},(data)=>{
		      		
		      		this.showfenpage = true
		      		this.lists = data.data
		      		this.totel= data.total
		      		for(var i=0;i<data.data.length;i++){
						if(data.data[i].nature == '0'){
							this.lists[i].nature = '居民'
						}
						if(data.data[i].nature == '1'){
							this.lists[i].nature = '自营'
						}
						if(data.data[i].nature == '2'){
							this.lists[i].nature = '联营'
						}
						if(data.data[i].nature == '3'){
							this.lists[i].nature = '出租'
						}
						if(data.data[i].nature == '4'){
							this.lists[i].nature = '物业动力'
						}
						if(data.data[i].nature == '5'){
							this.lists[i].nature = '居民配套'
						}
						if(data.data[i].nature == '9'){
							this.lists[i].nature = '备用'
						}
					}
		      	},(err)=>{
					return this.$message({
						type:'warning',
						message:err.msg,
						duration:1000
					})
				})
			},
			 handleSizeChange(val) {
		        console.log(`每页 ${val} 条`);
		    },
		    search(){
		    	
				let time = this.seach.value2
				let endTime = this.seach.value3
				let code = this.seach.code
				let account = this.seach.account
				let name = this.seach.owner_name
				let phone = this.seach.owner_phone
				let nature = this.seach.nature
				let communityName = this.seach.community_name
				let typess = this.seach.typess
		      	this.$jssdk.count.meterCharge({
		      		start_time:time,
		      		end_time:endTime,
					code:code,
					account: account,
		      		owner_name:name,
		      		owner_phone:phone,
		      		community_name:communityName,
		      		is_export:'0',
					  nature:nature,
					  type: typess,
		      	},(data)=>{
		      		console.log(data.all_total)
		      		this.showfenpage = true
		      		this.lists = data.data
		      		this.totel= data.total
		      		this.allTotal = data.all_total
		      		for(var i=0;i<data.data.length;i++){
						if(data.data[i].nature == '0'){
							this.lists[i].nature = '居民'
						}
						if(data.data[i].nature == '1'){
							this.lists[i].nature = '自营'
						}
						if(data.data[i].nature == '2'){
							this.lists[i].nature = '联营'
						}
						if(data.data[i].nature == '3'){
							this.lists[i].nature = '出租'
						}
						if(data.data[i].nature == '4'){
							this.lists[i].nature = '物业动力'
						}
						if(data.data[i].nature == '5'){
							this.lists[i].nature = '居民配套'
						}
						if(data.data[i].nature == '9'){
							this.lists[i].nature = '备用'
						}
					}
		      	},(err)=>{
					return this.$message({
						type:'warning',
						message:err.msg,
						duration:1000
					})
				})
			},
			downmeterCharge(){
				let time = this.seach.value2
				let endTime = this.seach.value3
				let code = this.seach.code
				let account = this.seach.account
				let name = this.seach.owner_name
				let phone = this.seach.owner_phone
				let communityName = this.seach.community_name
				let nature = this.seach.nature
				let typess = this.seach.typess
		      	this.$jssdk.count.meterCharge({
		      		start_time:time,
		      		end_time:endTime,
					code:code,
					account: account,
		      		owner_name:name,
		      		owner_phone:phone,
		      		community_name:communityName,
		      		is_export:'1',
		      		nature:nature,
		      		sort_by: this.prop,
					sort_to: this.order,
					type: typess
		      	},(data)=>{
		      		window.location.href=data.url
		      	},(err)=>{
					return this.$message({
						type:'warning',
						message:err.msg,
						duration:1000
					})
				})
			},
			//重置摁扭
			resetting(){
				this.seach.value2 =''
				this.seach.value3 =''
				this.seach.code =''
				this.seach.account = ''
				this.seach.owner_name =''
				this.seach.owner_phone =''
				this.seach.community_name =''
				this.seach.nature = ''
				this.seach.typess = ''
			},
		      handleCurrentChange(val) {
		   		let time = this.seach.value2
				let endTime = this.seach.value3
				let code = this.seach.code
				let account = this.seach.account
				let name = this.seach.owner_name
				let phone = this.seach.owner_phone
				let communityName = this.seach.community_name
				var address = this.seach.address
				let nature = this.seach.nature
				let typess = this.seach.typess
		      	this.$jssdk.count.meterCharge({
		      		start_time:time,
		      		end_time:endTime,
					code:code,
					account: account,
		      		owner_name:name,
		      		owner_phone:phone,
		      		community_name:communityName,
		      		page:val,
		      		nature:nature,
		      		sort_by: this.prop,
					sort_to: this.order,
					type: typess
		      	},(data)=>{
		      		this.showfenpage = true
		      		this.lists = data.data
		      		this.totel= data.total
		      		for(var i=0;i<data.data.length;i++){
						if(data.data[i].nature == '0'){
							this.lists[i].nature = '居民'
						}
						if(data.data[i].nature == '1'){
							this.lists[i].nature = '自营'
						}
						if(data.data[i].nature == '2'){
							this.lists[i].nature = '联营'
						}
						if(data.data[i].nature == '3'){
							this.lists[i].nature = '出租'
						}
						if(data.data[i].nature == '4'){
							this.lists[i].nature = '物业动力'
						}
						if(data.data[i].nature == '5'){
							this.lists[i].nature = '居民配套'
						}
						if(data.data[i].nature == '9'){
							this.lists[i].nature = '备用'
						}
					}
		      	})
		        console.log(`当前页: ${val}`);
		    },
		},
		computed:{
			naturesData(){
				return this.natures = this.nature
			},
			...mapState(['nature'])
		},
		watch:{
			totel(value){
				if(value !=0){
					return this.handleCurrentChange()
				}
			}
		},
	}
</script>

<style>
	.el-form-item{
		margin-bottom: 10px !important;
	}
	.meter-charge strong{
		margin: 10px 0;
		display: block;
		font-family: "微软雅黑";
		font-size: 15px;
		color:red;
		font-weight: 600;
	}
</style>


// WEBPACK FOOTER //
// meterCharge.vue?583ab530